// ReinforcementForm.jsx
import React from 'react';
import { Grid, TextField } from '@mui/material';

const ReinforcementForm = ({ formData, handleChange }) => (
  <Grid container spacing={2}>
    <Grid item xs={12}>
      <TextField
        label="Type"
        name="type"
        fullWidth
        value={formData.type || ''}
        onChange={handleChange}
      />
    </Grid>
    <Grid item xs={12}>
      <TextField
        label="Resistance"
        name="resistance"
        fullWidth
        value={formData.resistance || ''}
        onChange={handleChange}
      />
    </Grid>
  </Grid>
);

export default ReinforcementForm;
